import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'spread' })
export class SpreadPipe implements PipeTransform {
    transform(valueA: any, valueB: any): string {
        return { ...valueA, ...valueB };
    }
}
